import {Component, OnInit} from '@angular/core';
import {Validators, UntypedFormControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertaService} from 'src/app/util/alerta.service';
import {ClienteSesion} from 'src/app/model/cliente-sesion';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {Asistente} from '../../model/asistente';
import {VotacionService} from '../votacion.service';
import {functionUtil} from '../../util/functionConst';


@Component({
  selector: 'sura-validacion-asistente',
  templateUrl: './validacion-asistente.component.html',
  styleUrls: ['./validacion-asistente.component.scss']
})
export class ValidacionAsistenteComponent implements OnInit {

  newAsistente: Asistente = new Asistente();
  returnUrl = '';
  recaptchaStr = '';
  recaptchaReactive: UntypedFormControl;
  nroDocumentoValidacion: UntypedFormControl;
  nroAsambleaValidacion: UntypedFormControl;
  fnKeyDownNumeric = functionUtil.fnKeyDownNumeric;
  fnKeyDownAlphaNumeric = functionUtil.fnKeyDownAlphaNumeric;
  fnInputMaxLength = functionUtil.fnInputMaxLength;
  fnNumericMobile = functionUtil.fnNumericMobile;
  fnAlphaNumericMobile = functionUtil.fnAlphaNumericMobile;

  constructor(
    private _votacionService: VotacionService,
    private alertaService: AlertaService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.recaptchaReactive = new UntypedFormControl(null, Validators.required);
    this.nroDocumentoValidacion = new UntypedFormControl('', [Validators.required,
      Validators.maxLength(13),
      Validators.minLength(8),
      Validators.pattern('[a-zA-Z0-9]+')]);
    this.nroAsambleaValidacion = new UntypedFormControl('', [Validators.required,
      Validators.maxLength(6),
      Validators.pattern('[0-9]+')]);
  }

  ngOnInit() {
    // reset login status
    this._votacionService.logout();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/bienvenido';

    sessionStorage.removeItem('votanteactivo');
    sessionStorage.removeItem('estadoBienvenida');
    localStorage.removeItem('votanteActual');
    localStorage.setItem(ParametrosConst.EDICION_VOTO, "N");
  }

  onLoginClick(captchaRef: any): void {
    if (this.recaptchaStr) {
      captchaRef.reset();
    }
    captchaRef.execute();
  }

  /*Verificar el capctcha*/
  public resolved(captchaResponse: string): void {
    this.recaptchaStr = captchaResponse;
    if (this.recaptchaStr) {
      this.enviarFormulario();
    }
  }

  enviarFormulario() {
    if (this.isValido()) {
      this.validarAsistencia(this.newAsistente);
    } else {
      this.getErrorMessageNroDocumento();
      this.getErrorMessageNroAsamblea();
    }
  }

  validarAsistencia(_asistente: Asistente) {
    try {
      this._votacionService.verificarUsuario(_asistente).subscribe((response: any) => {
        localStorage.setItem(ParametrosConst.TOKEN_CLIENTE, response.token);
        this._votacionService.validarIdentidad(_asistente)
          .then(res => {
            const dataStore = new ClienteSesion();
            dataStore.token = localStorage.getItem(ParametrosConst.TOKEN_CLIENTE);
            dataStore.asistente = res[0];
            this._votacionService.setCurrentSession(dataStore);
            this._votacionService.obtenerPreguntaActiva(dataStore.asistente.idAsamblea,dataStore.asistente.id, dataStore.asistente.idFoto, 'M', 'P').then(r => {
              if (r instanceof Array && r.length === 0) {
                this.alertaService.info('Asamblea no iniciada o no cuentas con preguntas por responder.');
              } else {
                this.router.navigate([this.returnUrl]);
              }
            }).catch(err => {
              localStorage.setItem(ParametrosConst.EDICION_VOTO, "N");
              if(err == 'Participe o representante ya voto'){
                localStorage.setItem(ParametrosConst.EDICION_VOTO, "S");
              }
              this.router.navigate(['/bienvenido']);
            });
            localStorage.removeItem(ParametrosConst.TOKEN_CLIENTE);
          })
          .catch(err => {
            this.alertaService.error(err);
          });
      }, error => {
        this.alertaService.error(error);
      });
    } catch (error) {
      this.alertaService.error(error);
    }
  }

  /**
   * VALIDACION DE FORMULARIO
   */
  isValido() {
    return !this.nroDocumentoValidacion.invalid && !this.nroAsambleaValidacion.invalid;
  }

  getErrorMessageNroDocumento() {
    return this.nroDocumentoValidacion.hasError('required') ? 'Campo Obligatorio ' :
      this.nroDocumentoValidacion.hasError('maxlength') ? 'Max 13 caracteres' :
        this.nroDocumentoValidacion.hasError('minlength') ? 'Min. 8 caracteres ' :
          this.nroDocumentoValidacion.hasError('pattern') ? 'Solo se acepta letras y números' : '';
  }

  getErrorMessageNroAsamblea() {
    return this.nroAsambleaValidacion.hasError('required') ? 'Campo Obligatorio ' :
      this.nroAsambleaValidacion.hasError('maxlength') ? 'Max 6 caracteres' :
        this.nroAsambleaValidacion.hasError('pattern') ? 'Solo se acepta números' :
          '';
  }
}
